/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import { NewAbstractSelectField } from "./_NewAbstractSelectField"

export type ConcernOption = { value: "red" | "amber" | "green"; color: string; label: string }

export const concernOptions: ConcernOption[] = [
  { value: "red", color: "#d03b39", label: "High" },
  { value: "amber", color: "#e89b0c", label: "Medium" },
  { value: "green", color: "#46b282", label: "Low" },
]

export function getColorForConcern(concern: string): string {
  return concernOptions.find(option => option.value === concern)?.color ?? "#999"
}

export function getLabelForConcern(concern: string): string {
  return concernOptions.find(option => option.value === concern)?.label ?? concern ?? ""
}

export function ResultConcernSelectField({
  value,
  onChange,
}: {
  value: string
  onChange(value: string): void
}) {
  return (
    <NewAbstractSelectField<ConcernOption>
      label="Concern"
      value={value || null}
      onChange={opt => onChange(opt?.value || "")}
      keyExtractor={opt => opt.value}
      renderOption={opt => (
        <div
          css={css`
            display: flex;
            align-items: center;
            gap: 8px;
          `}
        >
          <div
            css={css`
              width: 10px;
              height: 10px;
              background: ${opt.color};
              border-radius: 50%;
            `}
          />
          {opt.label}
        </div>
      )}
      options={concernOptions}
      noSearch
      isClearable
    />
  )
}
